import { Fragment } from 'react';
import Icon from 'components/Icon';
import Image from 'components/Image';
import Picture from 'components/Picture';

const OnlineStore = () => (
  <Fragment>
    <section className="section section_online-store_1">
      <div className="wrapper">
        <div className="row">
          <div className="col col-6 col-tablet-12">
            <h1 className="title title_size_xl title_white _mb-20 _mt-127 _mt-tablet-0 _mt-quad-153">
              Create your online store
            </h1>
            <p className="text text_size_xl text_white section__text">
              <span className="text__break">
                Add your products and sell online
              </span>{' '}
              with a secure shopping cart.
            </p>
          </div>
          <div className="col col-6">
            <div className="section__image-wrap">
              <Picture className="section__image" src="img-10.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_online-store_2">
      <div className="wrapper">
        <div className="row">
          <div className="col col-5 col-tablet-12">
            <div className="_mt-110 _mt-tablet-0 _mb-tablet-60">
              <h2 className="title title_size_l _mb-16">
                <span className="title__break">Set up shop</span> in minutes
              </h2>
              <p className="text">
                <span className="text__break">
                  Just add your product photos, choose your
                </span>{' '}
                <span className="text__break">
                  {' '}
                  payment methods, select your delivery options
                </span>{' '}
                and your store is open for business.
              </p>
            </div>
          </div>
          <div className="col col-7 col-tablet-12">
            <div className="section__image-wrap">
              <Image src="img-158.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_online-store_3">
      <div className="wrapper">
        <div className="section__header-wrap _mb-38">
          <h2 className="title title_size_l title_white section__main-title _mb-21 _mb-note-10 _mb-phone-18">
            Showcase with product galleries
          </h2>
          <p className="text text_size_xl text_white section__main-text">
            Choose how you want your products to be displayed.
          </p>
        </div>
        <div className="row">
          <div className="col col-4 col-tablet-portrait-12">
            <div className="_mb-40">
              <div className="section__box section__box_first _mb-19">
                <Icon className="section__icon" icon="view-list" />
              </div>
              <p className="text text_size_xl text_white section__text">
                List view
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="_mb-40">
              <div className="section__box section__box_second _mb-19">
                <Icon className="section__icon" icon="view-grid" />
              </div>
              <p className="text text_size_xl text_white section__text">
                Grid view
              </p>
            </div>
          </div>
          <div className="col col-4 col-tablet-portrait-12">
            <div className="_mb-40">
              <div className="section__box section__box_third _mb-19">
                <Icon className="section__icon" icon="view-variants" />
              </div>
              <p className="text text_size_xl text_white section__text">
                Variants view
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_online-store_4">
      <div className="wrapper">
        <div className="row row-reverse-tablet section__row">
          <div className="col col-7 col-tablet-12 section__col">
            <div className="section__back-image-wrap">
              <Image src="img-14.png" />
            </div>
            <div className="section__front-image-wrap">
              <Image src="img-02.png" />

              <video
                className="video section__video"
                autoPlay
                loop
                muted
                playsInline
                poster={require('../public/images/img-165.png')}
              >
                <source
                  src={require('../public/video/laptop-screen-osp.mp4')}
                  type="video/mp4"
                />
              </video>
            </div>
          </div>
          <div className="col col-5 col-tablet-12">
            <div className="_mt-140 _mt-laptop-0 _mb-tablet-40">
              <h2 className="title title_size_l _mb-16">
                Get paid quickly and securely
              </h2>
              <p className="text _mb-28">
                Provide popular payment methods like PayPal or Stripe so your
                customers can enjoy quick, easy and secure shopping straight
                away. Give the option of multi currencies and start selling
                worldwide.
              </p>
              <div className="section__icons-wrap">
                <Icon
                  className="section__icon section__icon_first"
                  icon="visa"
                />
                <Icon
                  className="section__icon section__icon_second"
                  icon="mastercard"
                />
                <Icon
                  className="section__icon section__icon_third"
                  icon="amex"
                />
                <Icon
                  className="section__icon section__icon_fourth"
                  icon="paypal"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_online-store_5">
      <div className="wrapper">
        <div className="row">
          <div className="col col-6 col-tablet-12">
            <h2 className="title title_size_l _mb-16 _mt-148 _mt-laptop-88 _mt-tablet-0">
              Ship it anywhere
            </h2>
            <p className="text _mb-32">
              Deliver your products locally or internationally using the most
              popular carriers. You can set flat or calculated rates based on
              product weight. You'll also have full control over which shipping
              options are available to your visitors e.g. standard delivery,
              next day, overnight and more.
            </p>
            <div className="section__icons-wrap">
              <Icon
                className="section__icon section__icon_first"
                icon="ups-flat"
              />
              <Icon
                className="section__icon section__icon_second"
                icon="usps"
              />
              <Icon
                className="section__icon section__icon_third"
                icon="australia-post"
              />
              <span className="section__icon-div _mb-laptop-37 _mb-note-40" />
              <Icon
                className="section__icon section__icon_fourth"
                icon="correios"
              />
              <Icon
                className="section__icon section__icon_fifth"
                icon="fedex"
              />
            </div>
          </div>
          <div className="col col-6 col-tablet-12">
            <div className="section__image-wrap _mt-242 _mt-laptop-274 _mt-tablet-60">
              <Image src="img-26.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_online-store_6">
      <div className="wrapper">
        <h2 className="title title_size_l section__main-title _mb-57 _mb-tablet-0">
          Manage your Online Store
        </h2>
        <div className="row section__row">
          <div className="col col-5 col-laptop-6 col-tablet-12">
            <div className="_mt-41 _mt-laptop-0 _mt-tablet-41 _mb-tablet-60">
              <div className="row">
                <div className="col col-12 col-tablet-6 col-tablet-portrait-12">
                  <div className="section__item _mb-33 _mb-laptop-23">
                    <div className="section__icon-wrap _mt-13 _mb-col-tablet-portrait-11">
                      <Icon
                        className="section__icon section__icon_first"
                        icon="icon-17"
                      />
                    </div>
                    <div>
                      <h3 className="title section__title title_size_xs _mb-3">
                        Product Management
                      </h3>
                      <p className="text">
                        <span className="text__break">
                          Manage, edit, delete or change
                        </span>{' '}
                        your products anytime.
                      </p>
                    </div>
                  </div>
                  <div className="section__item _mb-33 _mb-laptop-23">
                    <div className="section__icon-wrap _mt-13 _mb-col-tablet-portrait-11">
                      <Icon
                        className="section__icon section__icon_second"
                        icon="icon-18"
                      />
                    </div>
                    <div>
                      <h3 className="title section__title title_size_xs _mb-3">
                        Promotions
                      </h3>
                      <p className="text">
                        <span className="text__break">
                          Create discount codes, offer free
                        </span>{' '}
                        shipping and other special deals.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col col-12 col-tablet-6 col-tablet-portrait-12">
                  <div className="section__item _mb-33 _mb-laptop-23">
                    <div className="section__icon-wrap _mt-13 _mb-col-tablet-portrait-11">
                      <Icon
                        className="section__icon section__icon_third"
                        icon="icon-19"
                      />
                    </div>
                    <div>
                      <h3 className="title section__title title_size_xs _mb-3">
                        Track Inventory
                      </h3>
                      <p className="text">
                        <span className="text__break">
                          Know the status of your products no
                        </span>{' '}
                        matter where you sell — online or offline.
                      </p>
                    </div>
                  </div>
                  <div className="section__item">
                    <div className="section__icon-wrap _mt-13 _mb-col-tablet-portrait-11">
                      <Icon
                        className="section__icon section__icon_fourth"
                        icon="icon-20"
                      />
                    </div>
                    <div>
                      <h3 className="title section__title title_size_xs _mb-3">
                        Worldwide Shipping & Tax
                      </h3>
                      <p className="text">
                        <span className="text__break">
                          Set tax rates based on regions and
                        </span>{' '}
                        shipping rules for each destination.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col col-7 col-laptop-6 col-tablet-12">
            <div className="section__image-wrap">
              <Image className="section__image" src="img-27.png" />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="section section_online-store_7">
      <div className="wrapper">
        <h2 className="title title_size_l section__main-title _mb-57">
          Reach more customers
        </h2>
        <div className="row">
          <div className="col col-4 col-tablet-portrait-12 _mb-tablet-60">
            <div className="section__image-wrap _mb-28">
              <Image
                className="section__image section__image_device_1 _mt-17"
                src="device-01.svg"
              />
            </div>
            <h3 className="title title_size_s section__title _mb-17">
              Sell on Facebook
            </h3>
            <p className="text section__text">
              Stop sharing and start selling directly from your Facebook page.
              Simply insert your Online Store.
            </p>
          </div>
          <div className="col col-4 col-tablet-portrait-12 _mb-tablet-60">
            <div className="section__image-wrap section__image-wrap_aligned_left _mb-28">
              <Image
                className="section__image section__image_device_2"
                src="device-02.svg"
              />
            </div>
            <h3 className="title title_size_s section__title _mb-17">
              Sell on Mobile
            </h3>
            <p className="text section__text">
              Your Online Store will look perfect on any smartphone or tablet
              device and automatically adapts to your customer’s screen size.
            </p>
          </div>
          <div className="col col-4 col-tablet-portrait-12 _mb-tablet-60">
            <div className="section__image-wrap _mb-28">
              <Image
                className="section__image section__image_device_3 _mt-13 _mt-tablet-0"
                src="device-03.svg"
              />
            </div>
            <h3 className="title title_size_s section__title _mb-17">
              Sell Everywhere
            </h3>
            <p className="text section__text">
              Add your Online Store to blogs and social networks and manage it
              all from Siteplus. Any changes are mirrored instantly across all
              sites.
            </p>
          </div>
        </div>
      </div>
    </section>
  </Fragment>
);

export default OnlineStore;
